import { FC, memo } from "react";
import { StyledPrice, StyledVat } from "./Price.styled";
import { convertPrice, getPriceArray } from "./utils";

import { PriceProps } from "./Price.interface";
// import { ex } from "@fullcalendar/core/internal-common";
import { useApi } from "@/api";

const Price: FC<PriceProps> = ({ amount, currency, fontSize, fontWeight, locale, extraText, showVat = false }) => {
  const { session } = useApi();
  
  const price = `${session.getUserCurrency()}${amount}` //convertPrice(amount, currency, locale);
  const priceArray = getPriceArray(price);

  return (
    <StyledPrice fontSize={fontSize} fontWeight={fontWeight}>
      {priceArray[0]} { extraText }
      {showVat && <StyledVat>ExVat</StyledVat>}
    </StyledPrice>
  );
};

export default memo(Price);